import { create } from 'zustand';
import api from '@/lib/api';
import { ROUTES } from '@/constants/routes';
import { User } from '@/lib/store';

interface AuthStore {
  user: User | null;
  token: string | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<boolean>;
}

export const useAuth = create<AuthStore>((set) => ({
  token: localStorage.getItem('accessToken'),
  loading: true,
  user: null,
  
  login: async (email: string, password: string) => {
    email = email.trim().toLowerCase();
    const response = await api.post(ROUTES.API.AUTH.LOGIN, { email, password });
    const access = response.data.access;
    localStorage.setItem('accessToken', access);
    set({ token: access });
    await useAuth.getState().checkAuth();
  },
  
  logout: async () => {
    localStorage.removeItem('accessToken');
    set({ token: null });
  },
  
  checkAuth: async () => {
    try {
      set({ loading: true });
      const response = await api.get('/auth/users/me');
      const token = localStorage.getItem('accessToken');
      set({ token, loading: false, user: response.data });
      return true;
    } catch (err) {
      localStorage.removeItem('accessToken');
      set({ token: null, loading: false, user: null });
      return false;
    }
  },
}));

// Initial auth check
useAuth.getState().checkAuth();